import React from 'react';
import PropTypes from 'prop-types';
import { TOOLTIP_CONTENT_POSITION } from '../../../constants/PropTypesShapes';

const getMessage = (message) => {
  if (typeof message === 'string') return <p>{message}</p>;
  return message;
};

function getTransformPosition(position) {
  if (typeof position === 'undefined' || !position.x || !position.y) {
    return {};
  }

  return { transform: `${`translate(${position.x}%,${position.y}%)`}` };
}

const TooltipContent = function ({ className, direction, message, active, id, tooltipContentPosition }) {
  const tooltipClasses = `${direction} pp-tooltip ${className}`;

  return (
    <div className={tooltipClasses} style={getTransformPosition(tooltipContentPosition)} aria-hidden={!active} id={id}>
      <div className="pp-tooltip-message">{getMessage(message)}</div>
    </div>
  );
};

TooltipContent.displayName = 'TooltipContent';

TooltipContent.propTypes = {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.element]).isRequired,
  direction: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  className: PropTypes.string,
  id: PropTypes.string,
  tooltipContentPosition: PropTypes.shape(TOOLTIP_CONTENT_POSITION),
};

export default TooltipContent;
